export const FinancialPlanningSW = {
  DAILY_LIFE: 'Vardagsliv',
  HOUSING: 'Boende',
  HOUSING_DESCRIPTION: 'hyra, lån, el, underhåll',
  FOOD_GROCERIES: 'Mat & dagligvaror',
  TRANSPORTATION: 'Transport',
  TRANSPORTATION_DESCRIPTION: 'bil, kollektivtrafik, bränsle, försäkring',
  HEALTH_WELLNESS: 'Hälsa & välmående',
  HEALTH_WELLNESS_DESCRIPTION: 'sjukvård, gym, försäkring',
  CLOTHING_PERSONAL_CARE: 'Kläder & personlig vård',
  DIGITAL: 'Teknik',
  DIGITAL_DESCRIPTION: 'mobil, internet, datorer',
  EVERYDAY_ACTIVITIES: 'Vardagsaktiviteter',
  EVERYDAY_ACTIVITIES_DESCRIPTION: 'barnomsorg, skolavgifter, medlemskap',
  CASUAL_EATING_OUT: 'Vardaglig utemat',
  CASUAL_EATING_OUT_DESCRIPTION: 't.ex. lunch ute, enkel middag',

  LIFESTYLE_EXPERIENCES: 'Livsstil & Upplevelser',
  TRAVEL_VACATIONS: 'Resor & semestrar',
  SECOND_HOME_OR_WEEKEND_CABIN: 'Fritidshus eller sommarstuga',
  PERSONAL_OR_CREATIVE_PROJECTS: 'Personliga eller kreativa projekt',
  PASSION_INVESTMENTS: 'Passionerade investeringar',
  PASSION_INVESTMENTS_DESCRIPTION: 'konst, vin, samlarobjekt',
  HOBBIES: 'Hobbies',
  HOBBIES_DESCRIPTION: 'utrustning, event, kurser',
  LIFESTYLE_UPGRADES: 'Lifestyle upgrades',
  LIFESTYLE_UPGRADES_DESCRIPTION: 'ex. köksrenovering, elbil',
  SPECIAL_DIETING_EVENTS: 'Speciella middagar & event',
  SPECIAL_DIETING_EVENTS_DESCRIPTION: 't.ex. middag på Frantzén',

  GIVING_AND_LEGACY: 'Givande & Arv',
  GIFTS_TO_CHILDREN: 'Gåvor till barn',
  GIFTS_TO_CHILDREN_DESCRIPTION: 't.ex. kontantinsats till lägenhet',
  SUPPORT_FOR_FAMILY_AND_FRIENDS: 'Stöd till familj eller vänner',
  CHARITABLE_DONATIONS: 'Välgörenhet och donationer',
  INHERITANCE_PLANNING: 'Arvsplanering',
  FAMILY_TRUST_OR_FUTURE_FUNDS: 'Familjefond eller framtidskonto',
  GIVE_WHILE_LIVING_GOALS: '“Ge medan du lever”-mål',

  Me: 'Mig',
  Family: 'Familj',
  'My Partner': 'Min partner',
  'With Friends': 'Med vänner',

  DESCRIPTION_OPTIONAL: 'Beskrivning (valfritt):',
  TAGS_OPTIONAL: 'Taggar (valfritt):',

  ESSENTIAL: 'Grundläggande',
  USEFUL: 'Användbar',
  NOT_AT_ALL: 'Inte alls',

  HIGHEST: 'Highest',
  MODERATE: 'Moderate',

  JOYFUL: 'Glad',
  CONTENT: 'Innehåll',
  NEUTRAL: 'Neutral',

  HOW_DOES_THIS_ALIGN_WITH_YOUR_NEEDS:
    'Hur stämmer detta överens med dina behov?',

  HOW_DOES_THIS_ALIGN_WITH_MY_PURPOSE:
    'Hur stämmer detta överens med mitt syfte?',
  HOW_HAPPY_DOES_IT_MAKE_YOU: 'Hur lycklig gör det dig?',
  HOW_ESSENTIAL_IS_THIS: 'Hur viktigt är detta?',
  HOW_OFTEN_DO_YOU_WANT_TO_DO_IT: 'Hur ofta vill du göra det?',
  WHEN_DO_YOU_USUALLY_PAY_FOR_THIS: 'När brukar man betala för detta?',
  WHEN_DO_YOU_WANT_TO_SPEND_ON_THIS: 'När vill du spendera på detta?',

  NECESSITY: 'Nödvändighet',
  PURPOSE_HAPPINESS: 'Syfte / Lycka',
  YRS: 'år',
};
